module.exports = __webpack_public_path__ + "static/img/lbbg3.1e6568f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbbg3.png
// module id = 2FrI
// module chunks = 0